import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'
import { APP_SENTRY_LOGGING, SENTRY_ENV, SENTRY_SERVICE } from '..'

const browserOptions: Sentry.BrowserOptions = {
  debug: SENTRY_ENV !== 'production',
  dsn: SENTRY_SERVICE,
  environment: SENTRY_ENV != null ? SENTRY_ENV : 'not set',
  release: (window as any).SENTRY_RELEASE?.id,
  defaultIntegrations: false,
  // TODO: Remove the check for APP_SENTRY_LOGGING when all apps are using the new app Sentry logic.
  integrations: () =>
    APP_SENTRY_LOGGING
      ? []
      : [
        ...Sentry.defaultIntegrations.filter((integration) => {
          return integration.name !== 'Dedupe'
        }),
        new BrowserTracing()
      ],
  beforeSend: (event) => {
    event.tags = { application: 'hb-header-app', 'event-created-in-application': 'hb-header-app' }
    return event
  }
}

export const sentryBrowserOptions = browserOptions
